// extracted by mini-css-extract-plugin
export default {"filters":"DevicesScreen_filters__gkngj"};